/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  useGetResourceGroupsQuery,
  GroupsSortInput,
  GroupsFilterInput,
  useGetResourceGroupsBasicQuery,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort?: GroupsSortInput;
  filter?: GroupsFilterInput;
  basic?: boolean;
  excludeResourceSelectors?: boolean;
  skip?: boolean;
};

export function useGetResourceGroups({
  page,
  limit,
  sort,
  filter,
  basic,
  excludeResourceSelectors,
  skip,
}: Props) {
  const variables = { page: Number(page), limit: Number(limit), sort, filter };
  const basicResult = useGetResourceGroupsBasicQuery({
    variables,
    skip: !basic || skip,
  });
  const fullResult = useGetResourceGroupsQuery({
    variables: { ...variables, excludeResourceSelectors },
    skip: !!basic || skip,
  });
  const queryResult = basic ? basicResult : fullResult;
  const { data, loading, error, refetch } = queryResult;
  const count = data?.groups.pageInfo?.count ?? 0;

  return {
    data: data?.groups?.result ?? [],
    loading,
    error,
    count,
    refetch,
  } as const;
}
